import { render, staticRenderFns } from "./LoginHelpModal.vue?vue&type=template&id=64bef89c"
import script from "./LoginHelpModal.vue?vue&type=script&lang=js"
export * from "./LoginHelpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports